import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import ContactCard from './ContactCard';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  accordion: {
    backgroundColor: '#960d3b61',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
  bubble: {
    borderRadius: 15,
    backgroundColor: 'white',
    color: 'black',
    width: 30,
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginRight: theme.spacing(1),
  },
}));

const ContactResults = ({ contacts }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={classes.root}>
      <Accordion className={classes.accordion} expanded={expanded} onChange={(_, isExpanded) => setExpanded(isExpanded)}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
        >
          <div className={classes.bubble}>{contacts.length}</div>
          <Typography className={classes.heading}>Contacts</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            {contacts.length > 0
              ? contacts.map((contact) => (
              <Grid item xs={12} key={contact.id}>
                <ContactCard contact={contact}/>
              </Grid>
              ))
              : (
              <Grid item xs={12}>
                <Typography>Aucun contact ne correspond à votre recherche</Typography>
              </Grid>
                )}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ContactResults;
